import React from 'react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'

// Inject keyframe animation once
let _stylesInjected = false
function injectTooltipStyles() {
    if (_stylesInjected || typeof document === 'undefined') return
    _stylesInjected = true
    const style = document.createElement('style')
    style.textContent = `
        @keyframes _tt-in  { from { opacity:0; transform: scale(0.94) translateY(3px); } to { opacity:1; transform: scale(1) translateY(0); } }
        @keyframes _tt-out { from { opacity:1; transform: scale(1)    translateY(0);   } to { opacity:0; transform: scale(0.94) translateY(3px); } }
        [data-radix-tooltip-content][data-state="delayed-open"],
        [data-radix-tooltip-content][data-state="instant-open"]  { animation: _tt-in  0.15s cubic-bezier(0.16,1,0.3,1); }
        [data-radix-tooltip-content][data-state="closed"]        { animation: _tt-out 0.1s ease-in; }
    `
    document.head.appendChild(style)
}

export const TooltipProvider = TooltipPrimitive.Provider

export const Tooltip = TooltipPrimitive.Root

export const TooltipTrigger = TooltipPrimitive.Trigger

export const TooltipContent = React.forwardRef<
    React.ElementRef<typeof TooltipPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ sideOffset = 6, ...props }, ref) => {
    injectTooltipStyles()
    return (
        <TooltipPrimitive.Portal>
            <TooltipPrimitive.Content
                ref={ref}
                sideOffset={sideOffset}
                style={{
                    backgroundColor: '#1f2937',
                    color: '#f9fafb',
                    fontSize: '12px',
                    fontWeight: 500,
                    padding: '5px 11px',
                    borderRadius: '7px',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                    zIndex: 9999,
                    whiteSpace: 'nowrap',
                }}
                {...props}
            >
                {props.children}
                <TooltipPrimitive.Arrow style={{ fill: '#1f2937' }} />
            </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
    )
})
TooltipContent.displayName = 'TooltipContent'
